export default __webpack_public_path__ + "static/media/search_mobile.c88d46bb.svg";